import ApiService from "../Services/ApiService";
import { Route } from "../Objects/enums/RouteEnum";

export interface ApiVersionSummary {
    /** Version au format affiché (3.4.0). */
    version: string;
    changelogCount: number;
}

export default abstract class ApiVersionRepository {
    public static getVersion(version: string) {
        return ApiService.get(`${Route.API_VERSIONS}/${version}`);
    }

    /** Versions qui ont un changelog, de la plus récente à la plus ancienne (page Quoi de neuf). */
    public static listVersions(): Promise<{ versions: ApiVersionSummary[] }> {
        return ApiService.get(Route.API_VERSIONS) as Promise<{ versions: ApiVersionSummary[] }>;
    }
}
